/*
 * @Author: csu chen.su@murata.com
 * @Date: 2022-06-22 15:36:49
 * @LastEditors: csu chen.su@murata.com
 * @LastEditTime: 2023-02-02 13:11:29
 * @FilePath: \frontend\src\utils\index.js
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
/*
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    return value.toString().padStart(2, '0');
  });
  return time_str;
}
*/

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
/*
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}
*/

/**
 * @param {string} url
 * @returns {Object}
 */
/*
export function param2Obj(url) {
  const search = url.split('?')[1];
  if (!search) {
    return {};
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"').replace(/\+/g, ' ') +
      '"}'
  );
}
*/

export function b64toBlob(b64Data, contentType, sliceSize) {
  // contentType = contentType || '';
  // sliceSize = sliceSize || 512;
  // var byteCharacters = atob(b64Data);
  // var byteArrays = [];
  // for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
  //   var slice = byteCharacters.slice(offset, offset + sliceSize);
  //   var byteNumbers = new Array(slice.length);
  //   for (var i = 0; i < slice.length; i++) {
  //     byteNumbers[i] = slice.charCodeAt(i);
  //   }
  //   var byteArray = new Uint8Array(byteNumbers);
  //   byteArrays.push(byteArray);
  // }
  // var blob = new Blob(byteArrays, { type: contentType });
  // return blob;
}

export async function retryBackoffWait(retryCount) {
  if (retryCount) {
    const backoff = (Math.pow(2, retryCount - 1) + Math.random()) * 1000;
    await new Promise((resolve) => setTimeout(resolve, backoff));
  }
}

/**
 * 現在の言語設定に応じて適切なサービス名を取得する
 * @param {Object} service - サービスオブジェクト
 * @param {string} service.serviceName - サービス名（英語）
 * @param {string} service.serviceNameJa - サービス名（日本語）
 * @returns {string} 現在の言語に対応したサービス名
 */
export function getLocalizedServiceName(service) {
  if (!service) return '';

  const currentLang = localStorage.getItem('local') || 'ja';

  // 日本語の場合は日本語名を使用
  if (currentLang === 'ja') {
    return service.serviceNameJa || service.serviceName || '';
  } else {
    // 英語の場合は英語名を使用
    return service.serviceName || service.serviceNameJa || '';
  }
}
